/**
 * Constants for the Table component
 */

export const defaultEmptyMessage = 'No data available';
export const defaultPadding = 120;
export const usedSelectionWidth = 50;
